import pb from "./pocketbase";
import { getUserInfo } from "./UserService";
import { normalizeUserRecord } from "../auth/authApi";

function looksLikeMongoId(s) {
  return typeof s === "string" && /^[a-f0-9]{24}$/i.test(s);
}

/**
 * Maps legacy `GET /profile/user/:username` `myUser` to the same shape as PocketBase + normalizeUserRecord.
 */
function mapLegacyMyUserToProfile(mu) {
  if (!mu || typeof mu !== "object") return null;

  let media = mu.mediaLinks;
  if (media == null) media = [];
  else if (typeof media === "string") {
    try {
      media = JSON.parse(media || "[]");
    } catch {
      media = [];
    }
  }
  if (!Array.isArray(media)) media = [];

  const mongoId = mu._id;
  let pbId =
    mu.pocketbaseId ||
    mu.pocketbase_id ||
    mu.pbUserId ||
    mu.pocketBaseId ||
    mu.pb_id ||
    null;

  if (!pbId && mu.id != null) {
    const sid = String(mu.id);
    if (!looksLikeMongoId(sid)) pbId = sid;
  }

  const profileImg = mu.profile_img || mu.profileImg;
  const avatar =
    mu.avatar ||
    (typeof profileImg === "string" && !/^https?:\/\//i.test(profileImg)
      ? profileImg
      : undefined);

  const out = {
    ...(pbId ? { id: pbId } : {}),
    username: mu.username,
    email: mu.email,
    fullName: mu.fullName,
    intro: mu.intro,
    nationality: mu.nationality,
    experience: mu.experience,
    sub_role: mu.sub_role || mu.subRole,
    sub_role_: mu.sub_role_,
    personalSite: mu.personalSite,
    personalBlog: mu.personalBlog,
    avatar,
    profile_img: profileImg,
    mediaLinks: media,
    legacyMongoId: mongoId != null ? String(mongoId) : undefined,
    _profileSource: "legacy",
  };

  return normalizeUserRecord(out);
}

/**
 * Loads a profile by username for the public profile page.
 * Tries PocketBase first; if rules block listing other users (403) or the user is missing, falls back to legacy HTTP API.
 */
export async function loadPublicProfile(usernameParam) {
  const u = String(usernameParam || "").trim();
  if (!u) throw new Error("Missing username");

  const legacyPromise = getUserInfo(u).catch(() => null);

  try {
    const record = await pb.collection("users").getFirstListItem(
      pb.filter("username = {:name}", { name: u }),
      { requestKey: null }
    );
    const legacyRes = await legacyPromise;
    const legacyMongoId = legacyRes?.data?.myUser?._id;
    return normalizeUserRecord({ ...record, legacyMongoId });
  } catch (err) {
    const legacyRes = await legacyPromise;
    const mu = legacyRes?.data?.myUser;
    if (!mu) throw err;
    const mapped = mapLegacyMyUserToProfile(mu);
    if (!mapped) throw err;
    return mapped;
  }
}
